import DateInput from '@components/input/in-date';
import PhoneInput from '@components/input/in-phone';
import SelectInput from '@components/input/in-select';
import SelectMultiInput from '@components/input/in-select-multi';

const ADD_SELECTOR = '.add-more';
const ITEM_SELECTOR = '.add-more-item';
const REMOVE_SELECTOR = '.remove-more';

const swapIndex = (s, newIndex) => {
    if (/\[0\]/.test(s)) {
        return s.replace(/\[0\]/, `[${newIndex}]`);
    }
    if (/_0\[\]/.test(s)) {
        return s.replace(/_0\[\]/, `_${newIndex}[]`);
    }

    return s.replace(/_0(_|$)/, `_${newIndex}$1`);
};

const addItem = ($container, isHidden = false) => {
    if (isHidden
        && !$container.is(':visible')
    ) {
        $container.prop('hidden', null);
        return;
    }

    const $children = $container.children();
    const newIndex = $container.data('next-index') || $children.length;
    const $oldChild = $children.first();

    // If there is a form with Parsley errors, reset them before cloning.
    $container.closest('form').parsley()?.reset();

    DateInput.destroy($oldChild);
    SelectInput.destroy($oldChild);
    SelectMultiInput.destroy($oldChild);

    const $newChild = $oldChild.clone(false);

    if (
        $oldChild.is(':hidden')
        && $newChild.hasClass('add-more-item-model')
    ) {
        $newChild.removeClass('add-more-item-model');
        $newChild.removeClass('d-none');
    }

    $newChild.find(REMOVE_SELECTOR).prop('hidden', false);

    $newChild.find('label').each(function () {
        const $label = $(this);

        $label.prop('for', swapIndex($label.prop('for'), newIndex));
    });

    $newChild.find(':input').each(function () {
        const $input = $(this);

        $input.prop('id', swapIndex($input.prop('id'), newIndex))
            .prop('name', swapIndex($input.prop('name'), newIndex))
            .prop('disabled', false);

        if ($input.is(':checkbox,:radio')) {
            if ($input.data('addmore-default')) {
                $input.prop('checked', true);
            } else {
                $input.prop('checked', false);
            }
        } else if ($input.is('select')) {
            if ($input.attr('data-select2-id')) {
                $input.attr('data-select2-id', swapIndex($input.attr('data-select2-id'), newIndex));
            }
        } else {
            $input.val('');
        }

        if ($input.attr('data-parsley-errors-container')) {
            $input.attr('data-parsley-errors-container', swapIndex($input.attr('data-parsley-errors-container'), newIndex));
        }

        if ($input.attr('data-parsley-required-if-any')) {
            const selectors = JSON.parse($input.attr('data-parsley-required-if-any')).selectors;
            const newData = {
                selectors: selectors.map(selector => swapIndex(selector, newIndex)),
            };

            $input.attr('data-parsley-required-if-any', JSON.stringify(newData));

            // Would be nice to use hasData() here, but the jQuery version
            // we're using prohibits it.
            if ($input.data().parsleyRequiredIfAny !== undefined) {
                $input.data('parsleyRequiredIfAny', newData);
            }
        }
    });

    $newChild.find('.add-more-item-index').each(function () {
        const $index = $(this);

        // Display indexes should be 1-based, not 0-based.
        $index.text(newIndex + 1);
    });

    $container.append($newChild);
    $container.data('next-index', newIndex + 1);

    DateInput.init($newChild);
    PhoneInput.init($newChild);
    SelectInput.init($newChild);
    SelectMultiInput.init($newChild);

    DateInput.init($oldChild);
    SelectInput.init($oldChild);
    SelectMultiInput.init($oldChild);
};

const AddMore = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        $scope.on('click', ADD_SELECTOR, function () {
            const $btn = $(this);
            const $container = $($btn.data('container'));
            const isHidden = $btn.data('hidden');

            addItem($container, isHidden);
            document.dispatchEvent(new CustomEvent('add-more:item-added'));
        });

        $scope.on('click', REMOVE_SELECTOR, function () {
            $(this).closest(ITEM_SELECTOR).remove();
            document.dispatchEvent(new CustomEvent('add-more:item-removed'));
        });
    },

};

export default AddMore;
